var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.8,17.86c-.38,0-.7,.31-.7,.7v2.55h-2.55c-.38,0-.7,.31-.7,.7s.31,.7,.7,.7h3.25c.38,0,.7-.31,.7-.7v-3.25c0-.38-.31-.7-.7-.7Zm-8.36,3.25h-2.55v-2.55c0-.38-.31-.7-.7-.7s-.7,.31-.7,.7v3.25c0,.38,.31,.7,.7,.7h3.25c.38,0,.7-.31,.7-.7s-.31-.7-.7-.7Zm8.36-11.61h-3.25c-.38,0-.7,.31-.7,.7s.31,.7,.7,.7h2.55v2.55c0,.38,.31,.7,.7,.7s.7-.31,.7-.7v-3.25c0-.38-.31-.7-.7-.7Zm-8.36,0h-3.25c-.38,0-.7,.31-.7,.7v3.25c0,.38,.31,.7,.7,.7s.7-.31,.7-.7v-2.55h2.55c.38,0,.7-.31,.7-.7s-.31-.7-.7-.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.5,16c0,.27,.22,.48,.48,.48h1.54v1.54c0,.27,.22,.48,.48,.48s.48-.22,.48-.48v-1.54h1.54c.27,0,.48-.22,.48-.48s-.22-.48-.48-.48h-1.54v-1.54c0-.27-.22-.48-.48-.48s-.48,.22-.48,.48v1.54h-1.54c-.27,0-.48,.22-.48,.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms5);
export default __webpack_public_path__ + "static/media/72-ms-5.db89fee9f1c0ff26c41afd3d2c85e42e.svg";
export { ForwardRef as ReactComponent };